var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "blubber_globalstream",
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "scroll",
              rawName: "v-scroll",
            },
          ],
          staticClass: "scrollable_area",
        },
        [
          _c("blubber-public-composer"),
          _vm._v(" "),
          _c(
            "ol",
            {
              staticClass: "postings",
              attrs: {
                "aria-live": "polite",
              },
            },
            [
              _vm.streamData.more_up
                ? _c(
                    "li",
                    {
                      staticClass: "more",
                    },
                    [
                      _c("studip-asset-img", {
                        attrs: {
                          file: "loading-indicator.svg",
                          width: "20",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.sortedPostings, function (blubber) {
                return _c(
                  "li",
                  {
                    key: blubber.thread_id,
                    class: blubber.class,
                    attrs: {
                      "data-thread_id": blubber.thread_id,
                    },
                  },
                  [
                    blubber.html
                      ? _c(
                          "div",
                          {
                            staticClass: "thread_posting",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "contextinfo",
                              },
                              [
                                _c("studip-date-time", {
                                  attrs: {
                                    timestamp: blubber.mkdate,
                                    relative: true,
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", [_vm._v(_vm._s(blubber.user_name))]),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "avatar",
                                  style: {
                                    backgroundImage:
                                      "url(" + blubber.avatar + ")",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "content",
                              domProps: {
                                innerHTML: _vm._s(blubber.html),
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "translate",
                                    rawName: "v-translate",
                                  },
                                ],
                                staticClass: "link_to_comments",
                                attrs: {
                                  href: _vm.link(blubber.thread_id),
                                },
                                on: {
                                  click: function click($event) {
                                    $event.preventDefault()
                                    return _vm.changeActiveThread.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [_vm._v("Zur Diskussion")]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                )
              }),
              _vm._v(" "),
              _vm.more_down
                ? _c(
                    "li",
                    {
                      staticClass: "more",
                    },
                    [
                      _c("studip-asset-img", {
                        attrs: {
                          file: "loading-indicator.svg",
                          width: "20",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }